import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/Index";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Categories from "./pages/Categories";
import Articles from "./pages/Articles";
import ArticleDetails from "./pages/ArticleDetails";
import ScrollToTop from "./components/ScrollToTop";
import Deals from "./pages/Deals";

// Admin Layout
import AdminLayout from "./components/admin/AdminLayout";

// Admin pages
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminArticles from "./pages/admin/Articles";
import AdminCategories from "./pages/admin/Categories";
import AdminDeals from "./pages/admin/Deals";
import AdminSubscriptions from "./pages/admin/Subscriptions";
import AdminMessages from "./pages/admin/Messages";
import ArticleEditor from "./pages/admin/ArticleEditor";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/article" element={<ArticleDetails />} />
          <Route path="/deals" element={<Deals />} />

          {/* Admin routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="articles" element={<AdminArticles />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="deals" element={<AdminDeals />} />
            <Route path="subscriptions" element={<AdminSubscriptions />} />
            <Route path="messages" element={<AdminMessages />} />
            <Route path="articles/create" element={<ArticleEditor />} />
            <Route path="articles/edit/:id" element={<ArticleEditor />} />
          </Route>

          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
